import PageComponent from '/root/workspace/JiaMeiHuiBackstage_3hGC/src/pages/combo/index';

const PageComponentName = PageComponent;

export default PageComponentName;
